module.exports = __webpack_public_path__ + "static/media/left.326f7970.png";